export default {
  label: {
    commandUrl: 'Url para enviar comandos',
    botKey: 'Clave del Bot',
  },
  button: {
    save: 'Guardar información',
  },
  message: {
    success: 'Contrato guardado con éxito',
    error: 'Error al guardar la información del contrato',
  },
};
